export const classes = {
  wrapper: 'h-screen border-r border-grey-4 dark:border-white/10 px-6 shrink-0',
  expanded: 'w-[475px]',
  collapsed: 'w-[100px]',
  content: 'flex flex-col h-full',
  loading:
    'h-full place-center text-xl text-grey-6 dark:text-mauve-3 font-normal',
  divider: 'mt-4 mb-0',
};
